var splitColumns = function(){
  var el = document.querySelectorAll("[data-splitColumns]");
  var newColumns = [];
  for(let e of el){
    var columns = e.getAttribute("data-splitColumns");

    var items = e.querySelectorAll("li.show");
    var itemCount = items.length-1;

    var splitCount =Math.floor(itemCount/columns);

    var listElement = document.createElement("ul");
    listElement.style.width = 100/columns + "%";
    var newCount = 0;
    for(let i of items){
      if(newCount > splitCount){
        newCount = 0;
        newColumns.push(listElement);
        listElement = document.createElement("ul");
        listElement.style.width = 100/columns + "%";
      }
      listElement.append(i);
      newCount++;
    }
    newColumns.push(listElement);
    //middleItem.parentNode.insertBefore("</ul>TESTING</ul>",middleItem)

    e.innerHTML = "";
    for(let c of newColumns){

      e.append(c);
    }

  }


}

window.addEventListener("DOMContentLoaded",function(){
  splitColumns();
});
